import React, { useEffect, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RoutePage from '../components/RoutePage';
import { message, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import ImageViewer from '../components/ImageViewer';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';

const ImageSlideShow = ({
    setPageHeader,
    config,
    urlData,
    src = 'dynamic',
    data,
    params,
    api = '/imageControlList'
}) => {
    if (setPageHeader) {
        setPageHeader("Image SlideShow");
    }
    const [pageConfig, setPageConfig] = useState();
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [loading, setLoading] = useState(true);
    const [imageList, setImageList] = useState()
    const [settings, setSettings] = useState({
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    });


    const getData = () => {
        if (src === 'dynamic') {
            liracrypt.get(api, { ...searchParams, ...params })
                .then(({ data }) => {
                    if (data.isSuccess) {
                        setImageList(data.data);
                        setPageConfig(data.config);
                        setSettings(data.config.settings);
                        setLoading(false);
                    } else {
                        message.error(data.message || 'Something went wrong')
                    }
                    setLoading(false);
                }
                ).catch(err => {
                    setLoading(false);
                    ApiErrorComp();
                    console.log(err);
                }
                )
        }
    }

    useEffect(() => {
        if (src === 'dynamic') {
            getData();
            let interval;
            if (pageConfig?.interval) {
                interval = setInterval(() => {
                    getData();
                }, pageConfig?.interval);
            }
            return (() => clearInterval(interval))
        }
    }, [pageConfig?.interval]);

    useEffect(() => {
        if (src === 'data') {
            setImageList(data)
            setPageConfig(config)
            setSettings(config?.settings);
            setLoading(false);
        }

    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', width: '90%', marginBottom: 20 }}>
            <div className="img-slider" style={{ width: '80%' }}>
                {
                    loading ?
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 60 }} />} />
                        </div> :
                        <Slider {...settings}>
                            {
                                imageList.map((x, i) => (
                                    <div key={i}>
                                        <ImageViewer imgStyle={pageConfig?.imgStyle} api={"/imagecontrol"} urlData={{ _id: x }} />
                                    </div>
                                ))
                            }
                        </Slider>
                }
            </div>
        </div>
    )
}

export default ImageSlideShow;